import { VideoOffIcon } from './VideoOffIcon';

/**
 * author: Google
 * id F4C3A814-205E-4F0A-9B3D-34B5777A4237
 * name video-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-off.svg
 * tags
 * - Video / Movie 
 * - Home Automation 
 */
export const VideocamOffIcon = VideoOffIcon;
export default VideocamOffIcon